/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from "react";

import { useNavigate } from "react-router-dom";

import Breadcrumbs from "@mui/material/Breadcrumbs";
import Grid from "@mui/material/Grid";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Header from "../header/Header";
import SompoTitle from "../title/SompoTitle";
import Footer from "../footer/Footer";
import { useScreenSize } from "../Theme";
import backImage from "../../images/background.png";

import SompoContext from "../../logic/context/SompoContext";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";

interface BaseFrameProps {
    width?: string;
    title?: string | string[]; // タイトルがHTMLの場合、テキストを抜き出し渡す
    titleNode?: React.ReactNode; // タイトルがHTMLの場合のみ使用
    breadcrumbs?: React.ReactNode[];
    content: React.ReactNode;
    footer?: React.ReactNode;
    footerHeight?: string;
}

const BaseFrame = (props: BaseFrameProps) => {
    const sompoContext = React.useContext(SompoContext);
    const navigate = useNavigate();

    const { width, title = "", titleNode, breadcrumbs, content, footer, footerHeight } = props;
    const { desktop } = useScreenSize();
    const containerWidth = width || "100%";

    const [validLogin, setValidLogin] = React.useState(true);
    React.useEffect(() => {
        // console.log("login check", sompoContext.userDetail);
        if ((sompoContext.userDetail || {}).faxNumber !== "1") {
            setValidLogin(false);
            showErrorMessage({
                message: "利用規約に同意していないユーザによるログインです。<br/>ログイン画面を表示します。",
                resolve: () => navigate("/"),
            });
        }
    }, []);

    const titles = [];
    if (title instanceof Array) {
        title.forEach((t) => titles.push(t));
    } else if (title) {
        titles.push(title);
    }

    const titleStyle = {
        pt: 1.5,
        px: 2,
        width: "100%",
    };

    return (
        validLogin && (
            <>
                <Header />
                <Grid
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="flex-start"
                    sx={{
                        width: "100%",
                        height: "100%",
                        backgroundImage: `url(${backImage})`,
                        backgroundPosition: "center center",
                        backgroundRepeat: "no-repeat",
                        backgroundAttachment: "fixed",
                        backgroundSize: "cover",
                    }}
                >
                    <Grid item sx={{ height: "64px" }}>
                        <Toolbar />
                    </Grid>
                    <Grid // スクロールバーにwidthを影響させないようにするため、1つ余分にGridを挟む
                        item
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{
                            height: `calc(100% - 64px - ${footer && footerHeight ? footerHeight : "0px"})`,
                            overflow: "auto",
                        }}
                    >
                        <Grid
                            item
                            display="flex"
                            flexDirection="column"
                            justifyContent="flex-start"
                            alignItems="center"
                            sx={{
                                width: { xs: "100%", sm: containerWidth, md: containerWidth },
                            }}
                        >
                            {desktop && breadcrumbs && titles.length > 0 && (
                                <>
                                    <Grid
                                        item
                                        sx={{
                                            pt: 1.5,
                                            px: 2,
                                            width: "100%",
                                        }}
                                    >
                                        <Breadcrumbs
                                            separator=">"
                                            sx={{
                                                color: "#7C8188",
                                                "& .MuiBreadcrumbs-ol": {
                                                    flexWrap: "nowrap",
                                                    overflow: "hidden",
                                                },
                                                "& .MuiBreadcrumbs-li": {
                                                    whiteSpace: "nowrap",
                                                },
                                                "& .MuiBreadcrumbs-li:last-child": {
                                                    overflow: "hidden",
                                                },
                                            }}
                                        >
                                            {breadcrumbs}
                                            <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                                {titles[0]}
                                            </Typography>
                                        </Breadcrumbs>
                                    </Grid>
                                </>
                            )}

                            {/** ↓↓ タイトル ↓↓ */}
                            {titleNode && (
                                <Grid item sx={titleStyle}>
                                    {titleNode}
                                </Grid>
                            )}
                            {!titleNode && titles.length > 0 && (
                                <>
                                    <Grid item sx={titleStyle}>
                                        {titles.map((e, i) => (
                                            <SompoTitle key={`BaseFrame-Title-${i}`} name={e} />
                                        ))}
                                    </Grid>
                                </>
                            )}
                            {/** ↑↑ タイトル ↑↑ */}

                            <Grid
                                item
                                flexGrow={1}
                                sx={{
                                    pt: 1.5,
                                    px: 2,
                                    width: "100%",
                                }}
                            >
                                {content}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {footer && <Footer height={footerHeight}>{footer}</Footer>}
            </>
        )
    );
};

export default BaseFrame;
